import { gql } from '@apollo/client';

export interface GetClassesResponse {
    classes: { id: string; name: string; schoolYear: string }[];
}

export const GET_CLASSES = gql`
    query Classes($schoolId: ID!) {
        classes(orderBy: { className: asc }, where: { school: { id: { equals: $schoolId } } }) {
            id
            name
            schoolYear
        }
    }
`;

export interface GetStudentsResponse {
    users: {
        id: string;
        name: string;
        email: string;
        studentProfile: {
            id: string;
            familyName?: string;
            givenName?: string;
            studentNumber: string;
            class: {
                id: string;
                className: string;
                schoolYear: string;
                school: {
                    schoolName: string;
                };
            };
        };
    }[];
    usersCount: number;
}

export const GET_STUDENTS = gql`
    query Students($skip: Int, $take: Int, $orderBy: [UserOrderByInput!], $where: UserWhereInput) {
        users(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
            id
            name
            email
            studentProfile {
                id
                familyName
                givenName
                studentNumber
                class {
                    id
                    className
                    schoolYear
                    school {
                        schoolName
                    }
                }
            }
        }
        usersCount(where: $where)
    }
`;

export interface UpdateUserVariables {
    userUpdateInput: {
        email?: string;
        name?: string;
        password?: string;
    };
    id: string;
}

export const UPDATE_USER = gql`
    mutation UpdateUser($userUpdateInput: UserUpdateInput!, $id: ID!) {
        updateUser(data: $userUpdateInput, where: { id: $id }) {
            id
        }
    }
`;

export interface UpdateStudentVariables {
    studentProfileUpdateInput: {
        familyName?: string;
        givenName?: string;
        studentNumber?: string;
        class?: {
            connect: {
                id: string;
            };
        };
    };
    studentProfileId: string;
}

export const UPDATE_STUDENT = gql`
    mutation UpdateStudent($studentProfileUpdateInput: StudentProfileUpdateInput!, $studentProfileId: ID!) {
        updateStudentProfile(data: $studentProfileUpdateInput, where: { id: $studentProfileId }) {
            id
        }
    }
`;

export type CreateStudentSessionResponse = {
    authenticateWithClassroom:
        | { item: { id: string; __typename: 'StudentProfile' }; sessionToken: string; __typename: 'AuthenticateWithClassroomSuccess' }
        | { message: string; __typename: 'AuthenticateWithClassroomFailure' };
};

export type CreateStudentSessionVariables = {
    studentProfileId: string;
    ttl?: number;
};

export const CREATE_STUDENT_SESSION = gql`
    mutation AuthenticateWithClassroom($studentProfileId: ID!, $ttl: Int) {
        authenticateWithClassroom(studentProfileId: $studentProfileId, ttl: $ttl) {
            ... on AuthenticateWithClassroomSuccess {
                sessionToken
                item {
                    id
                }
            }
            ... on AuthenticateWithClassroomFailure {
                message
            }
        }
    }
`;

type StudentVariables = {
    email: string;
    role: 'student';
    password: string;
    name: string;
    studentProfile: {
        create: {
            studentNumber?: string;
            familyName?: string;
            givenName?: string;
            class?: {
                connect: {
                    id: string;
                };
            };
        };
    };
};

export type CreateStudentVariables = {
    userCreateInput: StudentVariables;
};

export const CREATE_STUDENT = gql`
    mutation CreateStudent($userCreateInput: UserCreateInput!) {
        createUser(data: $userCreateInput) {
            id
        }
    }
`;

export type CreateStudentsVariables = {
    userCreateInputs: StudentVariables[];
};

export const CREATE_STUDENTS = gql`
    mutation CreateStudent($userCreateInputs: [UserCreateInput!]!) {
        createUsers(data: $userCreateInputs) {
            id
        }
    }
`;
